export default __webpack_public_path__ + "img/homepage.section4.03.asset.6512233d.jpg";